import V from "gcl";
import C from "vesh";
import Q from "querystring";

/**
 * MsSQL库表转换器
 * >
 * >=
 * <
 * <=
 * =
 * !=
 * ~= in
 * !~= not in
 * @= find_in_set
 * !@= not find_in_set
 * %= like
 * !%= not like
 * && and 嵌套
 * || or 嵌套
 */
export const EMBMsSQLConverter = class {
  constructor(isStrict = false) {
    const { _, __ } = pri(this, {
      opes: {},
      isStrict,
      // getValue: v => ((v ? ((v.value !== undefined && v.value !== null) ? v.value : (v || '')) : '') + '').replace(/;/g, '_'),
      getValue: (v) =>
        undefined === v || undefined === v.value
          ? undefined
          : (v.value !== null ? v.value + "" : "").replace(/;/g, "_").trim(),
      tindex: "a,b,c,d,e,f,g,h,i,j,k,l,m,n,o,p,q,r,s,t,u,v,w,x,y,z".split(","),
      jopes: {
        "+": "inner join",
        ">+": "left join",
        "<+": "right join",
        ",": ",",
      },
      getTable(database, table, params) {
        var opes = table.match(/[<>]?\+|\,/g);
        if (opes) {
          var tables = table.split(/[<>]?\+|\,/);
          if (tables.length > 26) throw new Error("连接表过多");
          if (tables.length - 1 != opes.length)
            throw new Error("连接符不匹配表数!");
          const nojoin = table.match(/\,/g);
          let options = [];
          if (!nojoin) {
            if (!params["+"]) throw new Error("缺少+参数作为on条件");
            options = eval(`[${__.getValue(params["+"])}]`)[0];
            delete params["+"];
            if (options.length != opes.length)
              throw new Error("连接条件不匹配表数!");
          } else if (params["+"]) {
            options = eval(`[${__.getValue(params["+"])}]`)[0];
            delete params["+"];
            if (options.length != opes.length)
              throw new Error("连接条件不匹配表数!");
            options.forEach(function (v) {
              for (var k in v) {
                params[k] = { value: v[k], isStandard: true };
              }
            });
          }

          let sb2 = V.sb();
          //+ jion <+ right join >+ left join
          tables.forEach(function (v, i) {
            if (i > 0) sb2.append(!nojoin ? ` ${__.jopes[opes[i - 1]]} ` : ",");
            sb2
              .append(`${database ? "." + database : ""}${v}`)
              .append(` ${__.tindex[i]} `);
            if (!nojoin && i > 0)
              sb2.append("on ").append(_.getOpe(options[i - 1], "and"));
          });
          const ret = sb2.clear();
          sb2 = null;
          return ret;
        } else if (table.match(/\|/g)) return "{tablename}";
        else
          return `${database ? database + "." : ""}${table}${!!params["_as"] ? " as a " : ""}`;
      },
    });
    ">,>=,=,<=,<,!=,~=,!~=,@,!@,@=,!@=,%=,!%=,&&,||,+"
      .split(",")
      .forEach((v) => (__.opes[v] = true));
  }

  getWhere(params, onlywhere = false) {
    const { __ } = pri(this);
    const paraname = {};
    for (var i in params)
      if (params[i] !== undefined && params[i].value !== undefined)
        paraname[i.toLowerCase()] = params[i];

    /**
     * 需要判断
     * _and
     * _or
     * _count
     * _order
     * _group
     * _page
     * todo or 和 and 不全 缺少对~/* /* /或者~/* /的辅助
     */
    let sb = V.sb();
    try {
      sb.append(this.getOpe(params, "and"));
      if (!V.isValid(sb.toString())) sb.append(" 1=1 ");
      if (!onlywhere) {
        if (__.getValue(paraname["_group"]))
          sb.append(` group by ${__.getValue(paraname["_group"])} `);
        if (__.getValue(paraname["_page"]) || __.getValue(paraname["_limit"])) {
        } else {
          if (__.getValue(paraname["_order"]))
            sb.append(` order by ${__.getValue(paraname["_order"])} `);
          if (__.getValue(paraname["_orderby"]))
            sb.append(` order by ${__.getValue(paraname["_orderby"])} `);
        }
      }

      return sb.clear();
    } finally {
      sb = null;
    }
  }

  /**
   * @test name (a,b)=>11
   * @test name (a,b)=>11
   * @param {*} params
   * @param {*} split
   */
  getOpe(params, split) {
    const { _, __ } = pri(this);
    let sb = V.sb();
    try {
      for (let k in params) {
        if (
          params[k] === undefined ||
          (params[k].isStandard !== undefined && params[k].value === undefined)
        ) {
          delete params[k];
          continue;
        }
        k = k.trim();
        if (
          k.startsWith("_") ||
          (!k.eq("+") && !k.eq("&&") && !k.eq("||") && !k.startsWith("$"))
        )
          continue;

        let v = __.getValue(params[k]);

        // let _v = params[k.trim("$")];
        //计算列替换
        // if (_v && (__.getValue(_v) + "").match(/[`(?"'\.\+\-*\/]/g))
        //   k = __.getValue(_v);

        if (typeof v == "string" && "?_NULL".eq(v) && !params["_NULL"]) {
          params["_NULL"] = { value: null, isStandard: true };
        }
        k = k.replace("?", "@");
        let i = 3;
        //有问题
        //if (!params[k.substr(1)]) params[k.substr(1)] = params[k];
        delete params[k];
        if (undefined === v) continue;
        if (
          __.opes[k] ||
          __.opes[v.toLowerCase().substr(0, i--)] ||
          __.opes[v.toLowerCase().substr(0, i--)] ||
          __.opes[v.substr(0, i--)]
        ) {
          let ope = i == 3 ? k : v.substr(0, i + 1).toLowerCase();
          k = k.trim("$");
          // k = k.substr(1);

          switch (ope) {
            case "+":
              //为on 特别准备 如果没有删除 那么说应需要在where中出现
              let options = eval(`[${params[ope]}]`)[0];
              options.forEach(function (v, i) {
                sb.append(_.getOpe(v, "and"));
              });
              break;
            case ">":
            case ">=":
            case "<":
            case "<=":
            case "!=":
              sb.append(
                ` ${
                  k.startsWith("@") || k.indexOf(".") >= 0 ? k : "[" + k + "]"
                } ${ope}`,
              );
              //k.match(/\./) ||
              if (
                !v.startsWith("'") &&
                !v.startsWith('"') &&
                !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
              )
                sb.append(v.substr(ope.length).replace(/^\?/g, "@"));
              else if (params[k] || v.indexOf("`") >= 0)
                sb.append(
                  v.indexOf("`") < 0
                    ? `'${v.substr(ope.length).trim('"').trim("'")}'`
                    : `[${v.substr(ope.length).trim("`")}]`,
                );
              else {
                k = "_" + k.replace(/\./g, "_") + V.random();
                sb.append(`@${k}`);
                params[k] = {
                  value: v
                    .substr(ope.length)
                    .replace(/("$)|(^")/g, "")
                    .replace(/('$)|(^')/g, ""),
                  isStandard: true,
                };
              }
              break;
            default:
              sb.append(
                ` ${
                  k.startsWith("@") || k.indexOf(".") >= 0
                    ? "isnull('" + k + "','')"
                    : k.match(/[`?"'\.\+\-*\/\(\)]/g)
                      ? k
                      : "[" + k + "]"
                } `,
              );
              if ("?_NULL".eq(v)) {
                sb.append("is NULL");
              } else {
                sb.append(`${ope} isnull(`);
                //k.match(/\./) ||
                if (
                  !v.startsWith("'") &&
                  !v.startsWith('"') &&
                  !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                )
                  sb.append(v.substr(ope.length).replace(/^\?/g, "@"));
                else if (params[k] || v.indexOf("`") >= 0)
                  sb.append(
                    v.indexOf("`") < 0
                      ? `'${v.substr(ope.length).trim('"').trim("'")}'`
                      : `[${v.substr(ope.length).trim("`")}]`,
                  );
                else {
                  k = "_" + k.replace(/\./g, "_") + V.random();
                  sb.append(`'@${k}`);
                  params[k] = {
                    value: v
                      .substr(ope.length)
                      .replace(/("$)|(^")/g, "")
                      .replace(/('$)|(^')/g, ""),
                    isStandard: true,
                  };
                }
              }
              break;
            case "~=":
              sb.append(
                ` ${
                  k.startsWith("@") || k.indexOf(".") >= 0 ? k : "[" + k + "]"
                } in (`,
              )
                .append(
                  v
                    .substr(2)
                    .replace(/[\(\)]/g, "")
                    .split(",")
                    .map((v2) =>
                      v2.startsWith("@") ||
                      v2.startsWith("`") ||
                      v2.startsWith("'") ||
                      v2.startsWith('"') ||
                      v2.indexOf(".") >= 0
                        ? v2.startsWith("`")
                          ? `'${v2.trim("`")}'`
                          : `'${v2.trim('"').trim("'")}'`
                        : `'${v2}'`,
                    )
                    .join(","),
                )
                .append(")");
              break;
            case "!~=":
              sb.append(
                ` ${
                  k.startsWith("@") || k.indexOf(".") >= 0 ? k : "[" + k + "]"
                } not in (`,
              )
                .append(
                  v
                    .substr(3)
                    .replace(/[\(\)]/g, "")
                    .split(",")
                    .map((v2) =>
                      v2.startsWith("@") ||
                      v2.startsWith("`") ||
                      v2.startsWith("'") ||
                      v2.startsWith('"') ||
                      v2.indexOf(".") >= 0
                        ? v2.startsWith("`")
                          ? `'${v2.trim("`")}'`
                          : `'${v2.trim('"').trim("'")}'`
                        : `'${v2}'`,
                    )
                    .join(","),
                )
                .append(")");
              break;
            case "@":
              sb.append(
                ` ${
                  k.startsWith("@") || k.indexOf(".") >= 0 ? k : "[" + k + "]"
                } between ${v
                  .substr(1)
                  .replace(/[\(\)]/g, "")
                  .split("|")
                  .map((v2) =>
                    v2.startsWith("@") ||
                    v2.startsWith("`") ||
                    v2.startsWith("'") ||
                    v2.startsWith('"') ||
                    v2.indexOf(".") >= 0
                      ? v2.startsWith("`")
                        ? `'${v2.trim("`")}'`
                        : `'${v2.trim('"').trim("'")}'`
                      : `'${v2}'`,
                  )
                  .join(" and ")} `,
              );
              break;
            case "!@":
              sb.append(
                ` ${
                  k.startsWith("@") || k.indexOf(".") >= 0 ? k : "[" + k + "]"
                } not between ${v
                  .substr(2)
                  .replace(/[\(\)]/g, "")
                  .split("|")
                  .map((v2) =>
                    v2.startsWith("@") ||
                    v2.startsWith("`") ||
                    v2.startsWith("'") ||
                    v2.startsWith('"') ||
                    v2.indexOf(".") >= 0
                      ? v2.startsWith("`")
                        ? `'${v2.trim("`")}'`
                        : `'${v2.trim('"').trim("'")}'`
                      : `'${v2}'`,
                  )
                  .join(" and ")} `,
              );
              break;
            case "@=":
              sb.append(
                ` charindex(${
                  (v.endWith("`") ? "" : '"') +
                  v.substr(2).replace(/['"]/g, '"') +
                  (v.endWith("`") ? "" : '"')
                },${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"})>0`,
              );
              break;
            case "!@=":
              sb.append(
                ` charindex(${
                  (v.endWith("`") ? "" : '"') +
                  v.substr(2).replace(/['"]/g, '"') +
                  (v.endWith("`") ? "" : '"')
                },${k.match(/[`?"'\.\+\-*\/\(\)]/g) ? k : "`" + k + "`"})<=0`,
              );
              break;
            case "%=":
              sb.append(
                ` ${
                  k.startsWith("@") || k.indexOf(".") >= 0 ? k : "[" + k + "]"
                } like '%${v
                  .substr(2)
                  .replace(/("$)|(^")/g, "")
                  .replace(/('$)|(^')/g, "")
                  .replace(/'/g, "''")}%'`,
              );
              break;
            case "!%=":
              sb.append(
                ` ${
                  k.startsWith("@") || k.indexOf(".") >= 0 ? k : "[" + k + "]"
                } not like '%${v
                  .substr(3)
                  .replace(/("$)|(^")/g, "")
                  .replace(/('$)|(^')/g, "")
                  .replace(/'/g, "''")}%'`,
              );
              break;
            case "&&":
              {
                let opes = eval(`[${v.trim()}]`)[0];
                if (!V.isArray(opes)) opes = [opes];
                sb.append(" (");
                opes.forEach(function (v, i) {
                  sb.append(_.getOpe(v, "and"));
                  for (let k2 in v) {
                    if (k2.startsWith("_")) params[k2] = v[k2];
                    //参数设定补偿
                  }
                  if (i < opes.length - 1) sb.append(" and ");
                });
                sb.append(" )");
              }
              //保证适配性更好
              break;
            case "||":
              {
                let opes = eval(`[${v.trim()}]`)[0];
                if (!V.isArray(opes)) opes = [opes];
                sb.append(" (");
                opes.forEach(function (v, i) {
                  sb.append(_.getOpe(v, "or"));
                  for (let k2 in v) {
                    if (k2.startsWith("_")) params[k2] = v[k2];
                    //参数设定补偿
                  }
                  if (i < opes.length - 1) sb.append(" or ");
                });
                sb.append(" )");
                //保证适配性更好
              }
              break;
          }
        } else {
          k = k.trim("$");
          // k = k.substr(1);

          sb.append(
            ` ${
              k.match(/[`?"'\.\+\-*\/\(\)]/g)
                ? "isnull('" + k + "','')"
                : "[" + k + "]"
            } `,
          );

          if ("?_NULL".eq(v)) {
            sb.append("is NULL");
          } else {
            sb.append("= isnull(");
            //k.match(/\./) ||
            if (
              !v.startsWith("'") &&
              !v.startsWith('"') &&
              !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
            )
              sb.append(v.replace(/^\?/g, "@"));
            else if (params[k] || v.indexOf("`") >= 0)
              sb.append(
                v.indexOf("`") < 0
                  ? `'${v.trim('"').trim("'")}'`
                  : `[${v.trim("`")}]`,
              );
            else {
              k = "_" + k.replace(/[\.\?\$\(\)]/g, "_");
              sb.append(`@${k}`);
              params[k] = {
                value: v.replace(/("$)|(^")/g, "").replace(/('$)|(^')/g, ""),
                isStandard: true,
              };
            }
            sb.append(",'')");
          }
        }
        sb.append(` ${split} `);
      }
      return sb.clear().trim(` ${split} `);
    } finally {
      sb = null;
    }
  }

  lstParams(params, func, split = ",") {
    let sb = V.sb();
    try {
      for (let k in params) {
        let v = params[k];
        !k.startsWith("_") &&
          !k.startsWith("$") &&
          k.indexOf(";") < 0 &&
          typeof v != "function" &&
          sb.append(func(k, v)).append(split);
      }
      return sb.clear().trim(split);
    } finally {
      sb = null;
    }
  }

  convert(cmd) {
    const { _, __ } = pri(this);
    var that = this;
    let command = cmd.command || "",
      params = cmd.params,
      paraname = {};
    for (var i in params) {
      //防止注入
      if (!!i.match(/;/)) delete params[i];
      else paraname[i.toLowerCase()] = params[i];
    }
    const cmds = command.replace(/[\\\/]/g, ".").split("."); //必须三级划分
    let sb = V.sb();
    //const ID = params._ID || params._IID; //_IID:自增AutoIncrease ID
    try {
      switch (cmds.length) {
        case 4:
          {
            /**
             * id 主键
             * column 修改表
             * index 索引
             * add
             * drop
             * CREATE INDEX ix_name ON test (keyId) --索引建立
             *  CREATE UNIQUE INDEX ix_2 ON test (keyId)--索引建立
             *   ALTER TABLE test ADD PRIMARY KEY (keyId)--添加主键
             *    DROP INDEX ix_name ON test  --删除索引
             *   alter table periodical add constraint a primary key(autoid);增加主键
             * alter table periodical drop constraint a;删除主键
             * alter table table_name add column_name column_tpye          ----增加列
             * alter table table_name alter column column_name column_type
             * alter table table_name drop column column_name               ---删除列
             */
            const database = cmds[0].replace(/^[~_\.]$/, ""),
              table = cmds[1],
              obj = cmds[2].toLowerCase(),
              method = cmds[3];
            switch (method.toLowerCase()) {
              case "drop":
                database.length && sb.append(`use ${database};`);
                //sb.append(`alter table ${table} `);
                if (obj.eq("index")) {
                  let names = [];
                  for (var k in params)
                    if (!k.startsWith("$") && !k.startsWith("_"))
                      names.push(k.toLowerCase());
                  names.sort();
                  sb.append(
                    ` drop ${obj} IX_${V.hash(names.join(","))} on ${table}`,
                  ).append(";select 1 as count;");
                  names = null;
                } else if (obj.eq("id")) {
                  sb.append(
                    `alter table ${table} drop constraint a;select 1 as count;`,
                  );
                } else
                  sb.append(
                    that.lstParams(
                      params,
                      (k, v) => `alter table ${table} drop ${obj} [${k}]`,
                    ),
                  ).append(";select 1 as count;");
                break;
              case "change":
                database.length && sb.append(`use ${database};`);
                if (obj.eq("index")) {
                  let names = [];
                  for (var k in params)
                    if (!k.startsWith("$") && !k.startsWith("_"))
                      names.push(k.toLowerCase());
                  names.sort();
                  sb.append(
                    ` drop ${obj} IX_${V.hash(names.join(","))} on ${table}`,
                  ).append(";");
                  sb.append(
                    ` CREATE ${
                      params["_unique"] ? "UNIQUE" : ""
                    } ${obj} IX_${V.hash(names.join(","))}`,
                  )
                    .append(` on ${table}(`)
                    .append(
                      that.lstParams(
                        params,
                        (k, v) => `${k} ${__.getValue(v) || "ASC"}`,
                      ),
                    )
                    .append(");select 1 as count;");
                  names = null;
                } else if (obj.eq("id")) {
                  if (!__.getValue(paraname["_id"]))
                    throw new Error("请输入_ID参数");
                  sb.append(`alter table ${table} drop constraint a;`);
                  sb.append(
                    `alter table ${table} add constraint a PRIMARY KEY(${__.getValue(
                      paraname["_id"],
                    ).replace(/\+/g, ",")});`,
                  ).append(`select 1 as count;`);
                } else
                  sb.append(`alter table ${table} `)
                    .append(
                      that.lstParams(
                        params,
                        (k, v) =>
                          ` alter ${obj} [${k}] ${
                            __.getValue(v) || "VARCHAR(32)"
                          }`,
                      ),
                    )
                    .append(";select 1 as count;");
                break;
              case "add":
                database.length && sb.append(`use ${database};`);
                //sb.append(`alter table ${table}`);
                if (obj.eq("index")) {
                  let names = [];
                  for (var k in params)
                    if (!k.startsWith("$") && !k.startsWith("_"))
                      names.push(k.toLowerCase());
                  names.sort();
                  sb.append(
                    ` CREATE ${
                      params["_unique"] ? "UNIQUE" : ""
                    } ${obj} IX_${V.hash(names.join(","))}`,
                  )
                    .append(` on ${table}(`)
                    .append(
                      that.lstParams(
                        params,
                        (k, v) => `${k} ${__.getValue(v) || "ASC"}`,
                      ),
                    )
                    .append(");select 1 as count;");
                  names = null;
                } else if (obj.eq("id")) {
                  if (!__.getValue(paraname["_id"]))
                    throw new Error("请输入_ID参数");
                  sb.append(
                    `alter table ${table} add constraint a PRIMARY KEY(${__.getValue(
                      paraname["_id"],
                    ).replace(/\+/g, ",")});`,
                  ).append(`select 1 as count;`);
                } else
                  sb.append(
                    that.lstParams(
                      params,
                      (k, v) =>
                        `alter table ${table} add [${k}] ${
                          __.getValue(v) || "VARCHAR(32)"
                        }`,
                    ),
                  ).append(";select 1 as count;");
                break;
              default:
                throw new Error("未识别的命令" + command);
            }
          }
          break;
        case 3:
          /**
           * 库名/表名/操作
           * create 建表
           * drop 删除表
           * add 增加数据
           * del 删除数据
           * update 修改数据? 同名字段
           * select 查询数据
           * count 查询数据
           * sum 查询数据
           * edit 指明select,count,sum之外的操作
           * truncate
           * //todo replace
           */
          {
            const database = cmds[0].replace(/^[~_\.]$/, ""),
              table = cmds[1],
              method = cmds[2];
            switch (method.toLowerCase()) {
              case "createview":
                database.length && sb.append(`use ${database};`);
                sb.append(
                  `replace view ${table} as ${paraname["_sql"]};select 1 as count;`,
                );
                break;
              case "dropview":
                database.length && sb.append(`use ${database};`);
                sb.append(`drop view ${table};select 1 as count;`);
                break;
              case "create":
                //IF EXISTS (SELECT * FROM sys.all_objects WHERE object_id = OBJECT_ID(N'[dbo].[ff_schedule]') AND type IN ('U'))
                //RAISERROR ('表已存在，不能重复创建', 16, 1) WITH NOWAIT
                //GO
                /*CREATE TABLE dbo.Products  
                                (ProductID int PRIMARY KEY NOT NULL,  
                                ProductName varchar(25) NOT NULL,  
                                Price money NULL,  
                                ProductDescription text NULL)  
                                GO  */
                /* return session.Ni.excute('w_emb_event', '~.ff_test.create', {
                                   ID:'int  IDENTITY(1,1) NOT NULL',
                                   Type:'varchar(50) NOT NULL',
                                   Params:'nvarchar(2000) not null',
                                   _id:'ID',
                                   _index:'Type+Params',
                                   _debug:true
                                });*/
                database.length && sb.append(`use ${database};`);
                sb.append(
                  `IF EXISTS (SELECT * FROM sys.all_objects WHERE object_id = OBJECT_ID(N'[dbo].[${table}]') AND type IN ('U')) begin select 0 as count,'表已存在' as  error; end `,
                );
                sb.append(`else begin create table ${table}(`).append(
                  that.lstParams(
                    params,
                    (k, v) => `${k} ${__.getValue(v) || "[VARCHAR](32)"}`,
                  ),
                );
                if (V.isValid(paraname["_id"]))
                  sb.append(
                    `,constraint a PRIMARY KEY (${__.getValue(
                      paraname["_id"],
                    ).replace(/\+/g, ",")})`,
                  );
                sb.append(");select 1 as count;");
                if (V.isValid(paraname["_index"]))
                  __.getValue(paraname["_index"])
                    .split(",")
                    .map((v) =>
                      sb.append(`CREATE NONCLUSTERED INDEX [IX_${V.hash(
                        v,
                      )}] ON [dbo].[${table}] 
                                (${v
                                  .split("+")
                                  .map((v2) => `[${v2}]`)
                                  .join(",")});`),
                    );
                sb.append(" end");
                break;
              case "drop":
                database.length && sb.append(`use ${database};`);
                sb.append(`drop table ${table};select 1 as count;`);
                break;
              case "add":
                //insert into a (a,b,c) values (?a,?b,?c);select @@IDentity as ID,row_count as count;
                sb.append(
                  `insert into ${
                    database.length ? database + "." : ""
                  }${table} (`,
                );
                sb.append(that.lstParams(params, (k, v) => `[${k}]`)).append(
                  ")  values (",
                );
                sb.append(
                  that.lstParams(params, (k, v) => {
                    var val =
                      v && v.value === null ? "_NULL" : __.getValue(v) || "";
                    if ("?_GUID".eq(val))
                      params["_GUID"] = {
                        type: "varchar",
                        isStandard: true,
                        value: V.GUID(),
                      };

                    if ("?_SNOWID".eq(val))
                      params["_SNOWID"] = {
                        type: "varchar",
                        isStandard: true,
                        value: V.SNOWID(),
                      };

                    if ("?_NULL".eq(val) || "_NULL".eq(val)) {
                      params["_NULL"] = {
                        type: "varchar",
                        isStandard: true,
                        value: null,
                      };
                      return "null";
                    }
                    if (
                      !val.startsWith("'") &&
                      !val.startsWith('"') &&
                      !!val.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                    )
                      return val.replace(/^\?/g, "@");
                    else {
                      v.value = val
                        .replace(/("$)|(^")/g, "")
                        .replace(/('$)|(^')/g, "");
                      return `@${k}`;
                    }
                  }),
                ).append(
                  `);select @@IDentity as ID,@@ROWCOUNT as count${
                    params["_GUID"]
                      ? ",'" + params["_GUID"].value + "' as GUID"
                      : ""
                  }${
                    params["_SNOWID"]
                      ? ",'" + params["_SNOWID"].value + "' as SNOWID"
                      : ""
                  };`,
                );
                break;
              case "del":
                //delete from a where a=1 and b=2 and c=4 and (a=1 or b=2);select @@rowcount as count;
                {
                  sb.append("delete ");
                  if (table.match(/[<>]?\+|\,/g)) {
                    var delindex = __.tindex
                      .map(function (v) {
                        return !!params[v] ? v : null;
                      })
                      .filter(function (v) {
                        return !!v;
                      })
                      .join(",");
                    if (!delindex)
                      throw new Error("表连接未能说明需要删除的表 譬如a:true");
                    sb.append(delindex);
                  }
                  sb.append(
                    ` from ${__.getTable(database, table, params)} where `,
                  );
                  const where = that.getWhere(params, true);
                  if (where.trim().eq("1=1"))
                    throw new Error("不能无条件删除所有数据!");
                  sb.append(where).append(`;select @@rowcount as count;`);
                }
                break;
              case "truncate":
                //delete from a where a=1 and b=2 and c=4 and (a=1 or b=2);select @@rowcount as count;
                {
                  //const where = that.getWhere(params, true);
                  //if (where.trim().eq('1=1')) throw new Error('不能无条件删除所有数据!');
                  sb.append(
                    `truncate table ${
                      database.length ? database + "." : ""
                    }${table} ;select @@rowcount as count;`,
                  );
                }
                break;
              case "update":
                {
                  sb.append(
                    `update ${__.getTable(
                      database,
                      table.replace(/[<>]?\+/g, ","),
                      params,
                    )} set `,
                  );
                  var sbset = V.sb();
                  for (let k in params) {
                    let v = __.getValue(params[k]);
                    if (undefined === v) continue;
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sbset
                        .append(
                          (k.match(/\./) ? k : `[${k}]`) +
                            ` = ${
                              !v.startsWith("'") &&
                              !v.startsWith('"') &&
                              !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                                ? "?_null".eq(v)
                                  ? "null"
                                  : v.replace(/^\?/g, "@")
                                : v.startsWith("_")
                                  ? (function () {
                                      switch (v.toLowerCase()) {
                                        case "_increase":
                                          return "isnull([" + k + "],0)+1";
                                        case "_decrease":
                                          return (
                                            "case when [" +
                                            k +
                                            "]-1<0 then 0 else [" +
                                            k +
                                            "]-1 end"
                                          );
                                        case "_null":
                                          return "null";
                                        default:
                                          return "'" + v + "'";
                                      }
                                    })()
                                  : (function () {
                                      params[k].value = v
                                        .replace(/("$)|(^")/g, "")
                                        .replace(/('$)|(^')/g, "");
                                      if (k.match(/\./)) {
                                        var nk =
                                          k.replace(/\./g, "_") + V.random();
                                        params[nk] = params[k];
                                        delete params[k];
                                        k = nk;
                                      } else {
                                        params["@" + k] = params[k];
                                      }
                                      return "'" + v + "'";
                                    })()
                            }`,
                        )
                        .append(",");
                  }
                  sb.append(sbset.clear().trim(","))
                    .append(" where ")
                    .append(that.getWhere(params, true))
                    .append(`;select @@rowcount as count;`);
                  sbset = null;
                }
                break;
              case "select":
                {
                  //保证两次返回的值一定
                  const params2 = V.merge({}, params);
                  let sb2 = V.sb(),
                    sb3 = V.sb();
                  let _page =
                    __.getValue(paraname["_page"]) ||
                    __.getValue(paraname["_limit"]);
                  for (let k in params) {
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("+") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    ) {
                      const v = __.getValue(params[k]);
                      if (undefined === v) continue;
                      k = k.replace(/;/g, "_");
                      if (!!v.match(/[\.\?\(\)\+\-\*/]/)) {
                        sb2
                          .append(`${v.replace(/^\?/g, "@")} as '${k}'`)
                          .append(",");
                        _page && sb3.append(`[${k}]`).append(",");
                      } else if (k.match(/\./g)) {
                        sb2
                          .append(k)
                          .append(
                            (v + "").eq("true")
                              ? ""
                              : ` as '${v.trim('"').trim("'")}' `,
                          )
                          .append(",");
                        _page &&
                          sb3
                            .append(
                              "[" +
                                ((v + "").eq("true")
                                  ? k.split(".")[k.split(".") - 1]
                                  : v) +
                                "]",
                            )
                            .append(",");
                      } else {
                        sb2
                          .append(`[${k}]`)
                          .append(
                            (v + "").eq("true")
                              ? ""
                              : ` as '${v.trim('"').trim("'")}' `,
                          )
                          .append(",");
                        _page &&
                          sb3
                            .append("[" + ((v + "").eq("true") ? k : v) + "]")
                            .append(",");
                      }
                    }
                  }
                  if (0 == sb2.toString().length) {
                    if (__.isStrict) throw new Error("不能显示所有列");
                    else sb2.append("*");
                  }
                  sb2 = sb2.clear().trim(",");

                  if (_page) {
                    _page = _page.split(",");
                    if (_page.length != 2) {
                      throw new Error("_page参数错误");
                    }
                    let order = "order by ID asc";
                    if (__.getValue(paraname["_order"])) {
                      order = ` order by ${__.getValue(paraname["_order"])} `;
                    }
                    if (__.getValue(paraname["_orderby"])) {
                      order = ` order by ${__.getValue(paraname["_orderby"])} `;
                    }
                    sb.append(
                      "select " +
                        sb3.clear().trim(",") +
                        " from (select row_number() over(" +
                        order +
                        ") as _rows," +
                        sb2,
                    );
                  } else {
                    sb.append(
                      `select ${
                        V.isValid(__.getValue(params["_distinct"]))
                          ? "distinct "
                          : ""
                      }` + sb2,
                    );
                  }
                  let body = ` from ${__.getTable(database, table, params)} `;
                  params["_lock"] &&
                    (body += ` WITH (${
                      true === params["_lock"] ? "UPDLOCK" : params["_lock"]
                    }) `);
                  sb.append(body)
                    .append(`where ${that.getWhere(params)}`)
                    .append(
                      _page
                        ? `) as t where  _rows between ${
                            parseInt(_page[0]) * parseInt(_page[1])
                          } and ${
                            (parseInt(_page[0]) + 1) * parseInt(_page[1])
                          };`
                        : ";",
                    );
                  params["_count"] &&
                    sb
                      .append(
                        `select ${
                          V.isValid(__.getValue(params["_distinct"]))
                            ? "distinct "
                            : ""
                        }count(1) as count ${body} where `,
                      )
                      .append(that.getWhere(params2, true))
                      .append(";");
                  if (table.match(/[\|&]/g)) {
                    //| union & union all

                    const sql = sb.clear().trim(";");
                    const ope = table.match(/\|/g) ? "|" : "&";
                    sb.append(
                      table
                        .split(ope)
                        .map(function (v) {
                          return sql.replace(/\{tablename\}/g, v);
                        })
                        .join(ope.eq("|") ? " union " : " union all ") + ";",
                    );
                  }
                }
                break;
              case "count":
                {
                  sb.append(`select `).append(
                    (paraname["_group"]
                      ? __.getValue(paraname["_group"]) + ","
                      : "") || "",
                  );
                  const length = sb.toString().length;
                  var i = 1;
                  for (let k in params) {
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sb.append(
                        `count(${
                          V.isValid(__.getValue(params["_distinct"]))
                            ? "distinct "
                            : ""
                        }`,
                      )
                        .append(
                          k.match(/\./g)
                            ? k
                            : (__.getValue(params[k]) + "").match(/[\.\(,]/g)
                              ? __.getValue(params[k])
                              : `[${k}]`,
                        )
                        .append(`) as ${k.match(/\./g) ? "count" + i++ : k},`);
                  }
                  if (length == sb.toString().length)
                    throw new Error("count命令未设置统计列 例如 column1:true");
                  else sb.append(sb.clear().trim(","));

                  const body = __.getTable(database, table, params);
                  const where = that.getWhere(params);
                  sb.append(` from ${body} where `).append(where).append(";");
                  //params['_count'] && sb.append(`select count(*) as count from (${sb.toString().trim(';')}) a;`);
                  //todo 优化SQL
                }
                break;
              case "sum":
                {
                  sb.append(`select `).append(
                    (paraname["_group"]
                      ? __.getValue(paraname["_group"]) + ","
                      : "") || "",
                  );
                  const length = sb.toString().length;
                  var i = 1;
                  for (let k in params) {
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sb.append(
                        `sum(${
                          V.isValid(__.getValue(params["_distinct"]))
                            ? "distinct "
                            : ""
                        }`,
                      )
                        .append(
                          k.match(/\./g)
                            ? k
                            : (__.getValue(params[k]) + "").match(/[\.\(,]/g)
                              ? __.getValue(params[k])
                              : `[${k}]`,
                        )
                        .append(`) as ${k.match(/\./g) ? "count" + i++ : k},`);
                  }
                  if (length == sb.toString().length)
                    throw new Error("sum命令未设置统计列 例如 column1:true");
                  else sb.append(sb.clear().trim(","));

                  const body = __.getTable(database, table, params);
                  const where = that.getWhere(params);
                  sb.append(` from ${body} where `).append(where).append(";");
                  //params['_count'] && sb.append(`select count(*) as count from (${sb.toString().trim(';')}) a;`);
                  //todo 优化SQL
                }
                break;
              case "updateevent":
                {
                  var sbset = V.sb();
                  for (let k in params) {
                    let v = __.getValue(params[k]);
                    if (undefined === v) continue;
                    if (
                      !k.startsWith("_") &&
                      !k.startsWith("$") &&
                      !k.startsWith("&&") &&
                      !k.startsWith("||")
                    )
                      sbset
                        .append(
                          (k.match(/\./) ? k : `[${k}]`) +
                            ` = ${
                              !v.startsWith("'") &&
                              !v.startsWith('"') &&
                              !!v.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                                ? v.replace(/^\?/g, "@")
                                : v.startsWith("_")
                                  ? (function () {
                                      switch (v.toLowerCase()) {
                                        case "_increase":
                                          return "isnull([" + k + "],0)+1";
                                        case "_decrease":
                                          return (
                                            "case when [" +
                                            k +
                                            "]-1<0 then 0 else [" +
                                            k +
                                            "]-1 end"
                                          );
                                        case "_null":
                                          return "null";
                                        default:
                                          return "'" + v + "'";
                                      }
                                    })()
                                  : (function () {
                                      params[k].value = v
                                        .replace(/("$)|(^")/g, "")
                                        .replace(/('$)|(^')/g, "");
                                      if (k.match(/\./)) {
                                        var nk =
                                          k.replace(/\./g, "_") + V.random();
                                        params[nk] = params[k];
                                        delete params[k];
                                        k = nk;
                                      } else {
                                        params["@" + k] = params[k];
                                      }
                                      return "''''" + v + "''''";
                                    })()
                            }`,
                        )
                        .append(",");
                  }
                  var _table = __.getTable(
                    database,
                    table.replace(/[<>]?\+/g, ","),
                    params,
                  );
                  //Declare @q nvarchar(MAX);set @q=(select STUFF((SELECT ','''+CONVERT(varchar,ID)+'''' FROM ff_schedulehis where  [ID] in ('3015','3017') FOR XML PATH(''),Type).value('.','NVARCHAR(MAX)'),1,1,''));set @q=isnull(@q,'null');EXEC sp_executesql N'exec(''select * from ff_schedulehis where ID in(''+@q+'');update ff_schedulehis set [Params] = ''''3'''' where ID in(''+@q+'');select @@ROWCOUNT as count;select * from ff_schedulehis where ID  in(''+@q+'');'')',N'@q nvarchar(MAX)',@q;
                  sb.append("Declare @q nvarchar(MAX);");
                  sb.append(
                    "set @q=(select STUFF((SELECT ','''+CONVERT(varchar,ID)+'''' FROM " +
                      _table +
                      " where " +
                      that.getWhere(params, 2) +
                      " FOR XML PATH(''),Type).value('.','NVARCHAR(MAX)'),1,1,''))",
                  );
                  sb.append(
                    ";set @q=isnull(@q,'null');EXEC sp_executesql N'exec(''select * from " +
                      _table +
                      " where ID in(''+@q+'');update " +
                      _table +
                      " set " +
                      sbset.clear().trim(",") +
                      " where ID in(''+@q+'');select @@ROWCOUNT as count;select * from " +
                      _table +
                      " where ID  in(''+@q+'');'')',N'@q nvarchar(MAX)',@q;",
                  );
                  sbset = null;
                  // sb.clear();
                  // sb.append("Declare @q nvarchar(2000);set @q=(select STUFF((SELECT ','''+CONVERT(varchar,ID)+'''' FROM ff_schedulehis where  CAST(ID as varchar) in('1','2') FOR XML PATH(''),Type).value('.','NVARCHAR(MAX)'),1,1,''));EXEC sp_executesql N'exec(''select * from ff_schedulehis where CAST(ID as varchar) in(''+@q+'');update ff_schedulehis set Params = ''''[\"\"]'''' where CAST(ID as varchar) in(''+@q+'');select @@ROWCOUNT as count;select * from ff_schedulehis where CAST(ID as varchar) in(''+@q+'');'')',N'@q nvarchar(2000)',@q;");
                }
                break;
              case "addevent":
                //Declare @count int=0,@ID varchar(40)insert into ff_schedule([ExecuteTime],[Params],[Type],[CreateTime])  values (getdate(),@_GUID,@Type,getdate());set @count=@@ROWCOUNT;set @ID=CASE WHEN isnull(@@IDentity,0) !=0 THEN @@IDentity ELSE '318e8afea90f43af8d41efb606e83141' END;select @ID as ID,@count as count,'318e8afea90f43af8d41efb606e83141' as GUID;select * from ff_schedule where @count>0 and ID=@ID;
                {
                  let _table = __.getTable(
                    database,
                    table.replace(/[<>]?\+/g, ","),
                    params,
                  );
                  sb.append("Declare @count int=0,@ID varchar(40)");
                  sb.append("insert into ").append(_table).append("(");
                  sb.append(that.lstParams(params, (k, v) => `[${k}]`)).append(
                    ")  values (",
                  );
                  sb.append(
                    that.lstParams(params, (k, v) => {
                      var val =
                        v && v.value === null ? "_NULL" : __.getValue(v) || "";
                      if ("?_GUID".eq(val))
                        params["_GUID"] = {
                          type: "varchar",
                          isStandard: true,
                          value: V.GUID(),
                        };

                      if ("?_SNOWID".eq(val))
                        params["_SNOWID"] = {
                          type: "varchar",
                          isStandard: true,
                          value: V.SNOWID(),
                        };

                      if ("?_NULL".eq(val) || "_NULL".eq(val)) {
                        params["_NULL"] = {
                          type: "varchar",
                          isStandard: true,
                          value: null,
                        };
                        return "null";
                      }
                      if (
                        !val.startsWith("'") &&
                        !val.startsWith('"') &&
                        !!val.match(/\(|(\?[^,])|\+|\-|\*|\.|\/|`/)
                      )
                        return val.replace(/^\?/g, "@");
                      else {
                        v.value = val
                          .replace(/("$)|(^")/g, "")
                          .replace(/('$)|(^')/g, "");
                        return `@${k}`;
                      }
                    }),
                  )
                    .append(
                      ");set @count=@@ROWCOUNT;set @ID=CASE WHEN isnull(@@IDentity,0) !=0 THEN @@IDentity ELSE ",
                    )
                    .append(
                      params["_GUID"]
                        ? "'" + params["_GUID"].value + "'"
                        : "NULL",
                    )
                    .append(
                      params["_SNOWID"]
                        ? "'" + params["_SNOWID"].value + "'"
                        : "NULL",
                    )
                    .append(" END;select @ID as ID,@count as count")
                    .append(
                      params["_GUID"]
                        ? ",'" + params["_GUID"].value + "' as GUID"
                        : "",
                    )
                    .append(
                      params["_SNOWID"]
                        ? ",'" + params["_SNOWID"].value + "' as SNOWID"
                        : "",
                    );
                  sb.append(";select * from ")
                    .append(_table)
                    .append(" where @count>0 and ID=@ID;");
                }
                break;
              case "delevent":
                //Declare @q nvarchar(MAX);set @q=(select STUFF((SELECT ','''+CONVERT(varchar,ID)+'''' FROM ff_schedule where  [Type] = isnull(@_Type,'') FOR XML PATH(''),Type).value('.','NVARCHAR(MAX)'),1,1,''));set @q=isnull(@q,'null');EXEC sp_executesql N'exec(''select * from ff_schedule where ID in(''+@q+'');delete from ff_schedule where ID in(''+@q+'');select @@ROWCOUNT as count;'')',N'@q nvarchar(MAX)',@q;
                {
                  const where = that.getWhere(params, 2);
                  if (where.trim().eq("1=1"))
                    throw new Error("不能无条件删除所有数据!");
                  let _table = __.getTable(
                    database,
                    table.replace(/[<>]?\+/g, ","),
                    params,
                  );
                  sb.append("Declare @q nvarchar(MAX);");
                  sb.append(
                    "set @q=(select STUFF((SELECT ','''+CONVERT(varchar,ID)+'''' FROM " +
                      _table +
                      " where " +
                      where +
                      " FOR XML PATH(''),Type).value('.','NVARCHAR(MAX)'),1,1,''))",
                  );
                  sb.append(
                    ";set @q=isnull(@q,'null');EXEC sp_executesql N'exec(''select * from " +
                      _table +
                      " where ID in(''+@q+'');delete from " +
                      _table +
                      " where ID in(''+@q+'');select @@ROWCOUNT as count;'')',N'@q nvarchar(MAX)',@q;",
                  );
                }
                break;
              default:
                throw new Error("未识别的命令" + command);
            }
          }
          break;
        case 2:
          /**
           * 库名/操作
           * create 新建库
           * drop 删除库
           */
          {
            const database = cmds[0].replace(/^[~_\.]$/, ""),
              method = cmds[1];
            if (!database.length) throw new Error("请输入库名!");
            switch (method.toLowerCase()) {
              case "create":
                //todo 应该不好使
                sb.append(
                  `use [master];GO;create DATABASE ${database};select 1 as count;`,
                );
                break;
              case "drop":
                sb.append(`DROP DATABASE ${database};select 1 as count;`);
                break;
              default:
                throw new Error("未识别的命令" + command);
            }
          }
          break;
        default:
          throw new Error(
            "无法处理命令类型:" +
              command +
              "!请按照[库].表[.字段|索引].操作 方式设置命令!",
          );
      }
      cmd.command = sb.clear();
      if (__.getValue(paraname["_debug"]))
        console.log("mssql", cmd.command, cmd.params);
    } finally {
      sb = null;
    }
  }
};

export default {
  EMBMsSQLConverter,
};
const pri = V.pris();
